// src/components/layout/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import { FaGithub, FaTwitter, FaLinkedin } from 'react-icons/fa';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="main-footer">
            <div className="footer-container">
                <div className="footer-bottom">
                    <p>&copy; {currentYear} Akinwale Akinniranye. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
